/*
 * @Author: gjc
 * @Date: 2022-03-22 17:15:23
 * @LastEditors: gjc
 * @LastEditTime: 2022-03-23 16:32:42
 * @Description: 产业政策接口
 */
import request from "@/utils/request";

//主题筛选列表
export function getPolicyESThemes() {
  return request({
    url: "/policy/es/themes",
    method: "get",
  });
}

//项目类别筛选列表
export function getItemCategoryList(params) {
  return request({
    url: "/policy/listItemCategory",
    method: "get",
    params,
  });
}

//产业类别筛选列表
export function getIndustryCategoryList(params) {
  return request({
    url: "/policy/listIndustryCategory",
    method: "get",
    params,
  });
}

//发布机构筛选列表
export function getPolicyESDepts() {
  return request({
    url: "/policy/es/depts",
    method: "get",
  });
}

// 获取政策列表
export function getPolicyESList(data) {
  return request({
    url: "/policy/es/list",
    method: "post",
    data,
  });
}

// 获取政策详情
export function getPolicyESDetail(id,isShare) {
  return request({
    url: `/policy/es/detail/${id}/${isShare}`,
    method: "get",
  });
}